






































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import AppNavigationDrawer from '@/components/AppNavigationDrawer.vue'
import AppNavbarBottom from '@/components/AppNavbarBottom.vue'
import AppNotificationBar from '@/components/AppNotificationBar.vue'
import AppToast from '@/components/AppToast.vue'
import ClientUpdatedSnackBar from '@/components/ClientUpdatedSnackBar.vue'
import DialogApp from '@/components/DialogApp.vue'
import DialogConfirm from '@/components/DialogConfirm.vue'
import DialogFeature from '@/components/DialogFeature.vue'
import DialogMessage from '@/components/DialogMessage.vue'
import HelpModal from '@/components/HelpModal.vue'
import NotificationPopup from '@/components/NotificationPopup.vue'
import SplashScreen from '@/components/Splash.vue'
import Analytics from './services/Analytics'
export default Vue.extend({
    components: {
        AppNavigationDrawer,
        AppNavbarBottom,
        AppNotificationBar,
        AppToast,
        ClientUpdatedSnackBar,
        DialogApp,
        DialogConfirm,
        DialogFeature,
        DialogMessage,
        HelpModal,
        NotificationPopup,
        splash: SplashScreen
    },
    computed: {
        ...mapGetters([
            'appOverflow',
            'dialogApp',
            'dialogConfirm',
            'dialogFeature',
            'dialogMessage',
            'helpModal',
            'isApp',
            'isOffline',
            'notificationPopup',
            'tenantKey',
            'tenant',
            'user'
        ]),
        appDrawer: {
            get(): boolean {
                return this.$store.getters.appDrawer
            },
            set(value: boolean): void {
                this.$store.commit('appDrawerSet', value)
            }
        },
        appHeight(): string {
            //  Start with a default 100%
            const defHeight = '100%'

            //  If we are not on the app, just always use 100%
            if (!this.isApp) return defHeight

            //  Else, grab the device height
            const height = window.innerHeight

            //  Make the max height this
            return `${height}px`
        },
        contentPadding(): string {
            //  Check if we are on a mobile device
            const mobile = this.isApp || this.$vuetify.breakpoint.xsOnly

            //  Our height depends on if we are on the mobile app or not
            const height = mobile ? `${window.innerHeight - 80}px` : '100%'

            //  Regardless, we want a set max and normal height
            const style = `height: ${height}; max-height:${height};`

            //  Else, check if we should add padding
            const needPadding =
                this.toolbarsEnabled && this.tenant && this.$vuetify.breakpoint.smAndUp

            //  If we don't need padding, just return our height and max height
            if (!needPadding) return style

            //  Else, check if we need horizontal padding
            const horizontal = this.$vuetify.breakpoint.mdAndUp

            //  Create our padding string
            const padding = `padding: 48px 0px 0px ${
                horizontal ? this.drawerWidth : 0
            }px;`

            //  Return our style and padding combined
            return `${style} ${padding}`
        },
        drawerIsMin: {
            get(): boolean {
                return this.$store.getters.appDrawerIsMin
            },
            set(val: boolean): void {
                this.$store.commit('appDrawerIsMinSet', val)
            }
        },
        drawerWidth(): number {
            return this.drawerIsMin && this.$vuetify.breakpoint.mdAndUp ? 65 : 190
        },
        hotKeysEnabled(): boolean {
            // Checks if our hotkeys are enabled or not
            return this.$store.getters.settingGet('hotKeysEnabled')
        },
        toolbarsEnabled(): boolean {
            //  Hide toolbars if a user does NOT exist
            if (!this.user) return false

            //  Create an list of blocking routes
            const blockedRoutes = [
                '/register/',
                '/memberships',
                '/invitations/accept',
                '/account/password-reset'
            ]

            //  Get the current route
            const path = this.$route.path

            //  Check if the current route matches a blocked route
            const matches = blockedRoutes.filter((x) => path.includes(x))

            //  Check if a blocking match was found
            const isBlocked = matches.length > 0

            //  If the current route is blocked, return false
            if (isBlocked) return false

            //  Else, show toolbars
            return true
        }
    },
    methods: {
        openHotKeysMenu(): void {
            // Open keyboard shortcuts menu popup
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'Keyboard Shortcuts',
                color: 'primary',
                component: 'hot-keys-pop-up',
                closeable: true,
                width: '900px'
            })
        },
        // Enables drawer to be minimized with hotkeys if hotkeys are on
        minimizeDrawer(): boolean {
            // Allows shortkey event to occur, shortkey won't be activated if setting is turned off
            if (this.hotKeysEnabled.enabled) {
                return !this.drawerIsMin
            }
        }
    },
    watch: {
        isOffline(): void {
            //  If there is no internet connection set a closeable notification,
            if (this.isOffline === true) {
                this.$store.commit('appNotificationBarSet', {
                    message: 'Network Offline',
                    type: 'error',
                    closeable: true
                })
            } else {
                //  Else, remove the app notification bar
                this.$store.commit('appNotificationBarSet', null)
            }
        },
        // Fire a page event anytime user goes to different page in app
        $route(to, from) {
            Analytics.segmentPage(to, from)
        }
    }
})
